import { useMemo } from "react";
import { uniqueId } from "lodash";
import { ClusterSymbolDc, PolygonSymbolDc } from "@evergis/api";

import { GRADIENT_PREFIX, STROKE_MAX_WIDTH } from "../constants";

import { getGradientColors } from "../utils/getGradientColors";
import { getParameterValue } from "../../../evergis/core/classification/getFromClassified";

import { ParameterByAttribute, StyleSymbolType } from "../../../interfaces/style";

export const useSvgDrawParams = (symbol: StyleSymbolType) => {
  const fillId = useMemo(() => uniqueId(GRADIENT_PREFIX), []);
  const strokeId = useMemo(() => uniqueId(GRADIENT_PREFIX), []);

  const calcFillColor = (symbol as PolygonSymbolDc).fill?.color || (symbol as ClusterSymbolDc).fillColor;
  const fillColor = getParameterValue(calcFillColor as ParameterByAttribute<string>);
  const fillColors = getGradientColors(symbol);

  const calcStrokeColor = (symbol as PolygonSymbolDc).stroke?.color || (symbol as ClusterSymbolDc).strokeColor;
  const strokeColor = getParameterValue(calcStrokeColor as ParameterByAttribute<string>);
  const strokeColors = getGradientColors(symbol, "stroke");

  const calcStrokeWidth = (symbol as PolygonSymbolDc).stroke?.width || (symbol as ClusterSymbolDc).strokeWidth;
  const strokeWidth = calcStrokeWidth
    ? Math.min(getParameterValue(calcStrokeWidth as ParameterByAttribute<number>), STROKE_MAX_WIDTH)
    : 0;

  return {
    fillId,
    strokeId,
    fillColor,
    fillColors,
    strokeColor,
    strokeColors,
    strokeWidth,
  };
};
